/**
 * Pre-compiled de messages for NumberInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { decrement: `Minderung`, increment: `Erhöhung` };
